<section>
  <div class="astral-form-stack astral-form-stack--relaxed">
    <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
      <app-autocomplete-remote
        [control]="form.controls['payer']"
        [service]="tenantService"
        (itemSelected)="onPayerSelected($event)"
      ></app-autocomplete-remote>

      @if (externalAccountsReceivable === true) {
        <astral-input
          [label]="'LEASE_AGREEMENT.INVOICE_DELIVERY_METHOD' | translate"
          [value]="'CONST.INVOICE_DELIVERY_METHOD_EXTERNAL_ACCOUNTS_RECEIVABLE' | translate"
          [readonly]="true"
        ></astral-input>
      } @else if (externalAccountsReceivable === false) {
        <app-invoice-delivery-method
          [control]="form.controls['invoiceDeliveryMethod']"
          [company]="company"
          [payer]="form.controls['payer'].value"
          [allowNoDelivery]="true"
          [helpText]="invoiceDeliveryHelpText"
        ></app-invoice-delivery-method>
      }

      @if (externalAccountsReceivable === false && displayPayerEmail) {
        <astral-input
          [control]="form.controls['payerEmailInvoicing']"
          [helpText]="'LEASE_AGREEMENT.HELP_TEXT.INVOICE_DELIVERY_METHOD_EMAIL'"
          [type]="'email'"
          [inputMode]="'email'"
        ></astral-input>
      }

      @if (externalAccountsReceivable === false && displayContractSpecificEmail) {
        <astral-input
          [control]="form.controls['emailInvoicing']"
          [helpText]="'LEASE_AGREEMENT.HELP_TEXT.INVOICE_DELIVERY_METHOD_EMAIL_CONTRACT_SPECIFIC'"
          [type]="'email'"
          [inputMode]="'email'"
        ></astral-input>
      }
    </astral-layout-group>

    <astral-layout-group [columns]="1" [tabletColumns]="1" [mobileColumns]="1">
      @if (externalAccountsReceivable === false && deliveryMethodEmail) {
        <astral-checkbox
          [control]="form.controls['useContractSpecificInvoicingEmail']"
          [helpText]="'LEASE_AGREEMENT.HELP_TEXT.INVOICE_DELIVERY_METHOD_EMAIL_CONTRACT_SPECIFIC'"
        ></astral-checkbox>
      }
    </astral-layout-group>

    <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
      <astral-select
        [control]="form.controls['invoicePeriod']"
        [itemsSource]="invoicePeriods"
        [helpText]="'LEASE_AGREEMENT.HELP_TEXT.INVOICE_PERIOD_LABEL'"
      ></astral-select>

      @if (displayYearlyDueDateControls) {
        <astral-select
          [control]="form.controls['periodFromStartMonth']"
          [itemsSource]="periodsFrom"
          [helpText]="'DUE_PERIODS.HELP_TEXT.YEARLY_DUE_DATE_MONTH'"
        ></astral-select>
      }

      <astral-select
        [control]="form.controls['dueDateMonthOffset']"
        [itemsSource]="dueDateMonths"
        [helpText]="'DUE_PERIODS.HELP_TEXT.DUE_DATE_MONTH_OFFSET'"
      ></astral-select>

      <astral-select
        [control]="form.controls['yearlyDueDateDay']"
        [itemsSource]="yearlyDueDateDays"
        [helpText]="'DUE_PERIODS.HELP_TEXT.YEARLY_DUE_DATE_DAY'"
      ></astral-select>

      <div class="create-button astral-link-action astral-form-adjacent-action">
        <astral-button variant="link-button" type="button" labelKey="DUE_PERIODS.OPEN_DUE_PERIODS" (click)="onOpenRentPeriodsClicked()">
        </astral-button>
      </div>
    </astral-layout-group>

    @if (externalAccountsReceivable === false) {
    <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
      <astral-toggle [control]="form.controls['invoicePayment']"></astral-toggle>
      @if (showDirectDebitControls && canRequestDirectDebit) {
        <astral-checkbox [control]="form.controls['createDirectDebit']"></astral-checkbox>
      }
    </astral-layout-group>

    @if (showDirectDebitControls) {
      <div class="astral-form-stack">
        @if (showDirectDebitStatus) {
          <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
            <div class="astral-layout-item">
              {{ dataContext.directDebitStatusDetailedCaption | translate
              }}@if (showDirectDebitTermination) {
              <span> {{ dataContext.directDebitTerminationDate }}</span>
            }
          </div>
          @if (canCancelDirectDebit) {
            <astral-checkbox [control]="form.controls['cancelDirectDebit']"></astral-checkbox>
          }
          @if (canResetRequestDate) {
            <astral-checkbox [control]="form.controls['resetDirectDebitRequestDate']"></astral-checkbox>
          }
        </astral-layout-group>
      }
      @if (showPayerInfo) {
        <astral-layout-group [columns]="2" [tabletColumns]="1" [mobileColumns]="1" [span]="'full'">
          <div class="astral-layout-item">
            <app-bank-account [dataContext]="bankAccount" [form]="form"></app-bank-account>
          </div>
          <astral-input [control]="form.controls['payerNumber']"></astral-input>
        </astral-layout-group>
      }
    </div>
  } @else {
    @if (showDirectDebitTermination) {
      <astral-layout-group
        [columns]="2"
        [tabletColumns]="2"
        [mobileColumns]="1"
        >
        <div class="astral-layout-item">{{ dataContext.directDebitStatusDetailedCaption | translate }}</div>
        <div class="astral-layout-item">{{ dataContext.directDebitTerminationDate }}</div>
      </astral-layout-group>
    }
  }
    }


  <astral-layout-group [columns]="1" [tabletColumns]="1" [mobileColumns]="1">
    <astral-input [control]="form.controls['labeling']" [helpText]="'LEASE_AGREEMENT.HELP_TEXT.LABELING'"></astral-input>
  </astral-layout-group>
</div>
</section>
